// extracted by mini-css-extract-plugin
module.exports = {"secondFold":"secondFold_secondFold__vqcMO"};